var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-defi std-view"},[(!_vm.currentAccount)?[_c('f-message',{attrs:{"type":"error","alert":"","with-icon":""}},[_vm._v("Bad wallet")])]:[_c('main',{staticClass:"main"},[_c('f-view-transition',{attrs:{"watch-route":"","views-structure":_vm.viewsStructure}},[_c('router-view')],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }